/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-subdomains-tree-node';

const prefix = `${moduleName}.${componentName}`;

export const hostAllSubdomainLabel = `${prefix}.hostAllSubdomainLabel`;

export const ENGLISH = {
    [hostAllSubdomainLabel]: 'Host All Subdomains',
};
